export default "__VITE_ASSET__V5hjJqiX__"